export default __webpack_public_path__ + "static/media/icono2gris.6636ba3c.svg";